import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "@rc-acs/shared/ui/globals.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
